import {CurrentTimetableWidget} from "./widgets/current-timetable";

export const widgets = {
    "bahn:current-timetable": CurrentTimetableWidget,
};